import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import SuperadminGuard from 'src/auth/guard/superadmin-guard';
import DashboardSuperadminLayout from 'src/layouts/dashboard/superadmin';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const UsersPage = lazy(() => import('src/pages/superadmin/users'));
const EntitiesPage = lazy(() => import('src/pages/superadmin/entities'));

// ----------------------------------------------------------------------

export const supervisorRoutes = [
  {
    element: (
      <AuthGuard>
        <SuperadminGuard>
          <DashboardSuperadminLayout>
            <Suspense fallback={<SplashScreen />}>
              <Outlet />
            </Suspense>
          </DashboardSuperadminLayout>
        </SuperadminGuard>
      </AuthGuard>
    ),
    children: [
      {
        path: 'superadmin',
        handle: {
          crumb: {
            i18nKey: 'common.superadmin',
            disabled: true,
          },
        },
        children: [
          {
            index: true,
            element: <Navigate to="/superadmin/users" replace />,
          },
          {
            path: 'users',
            element: <UsersPage />,
            handle: {
              crumb: {
                i18nKey: 'nav.menu.superadmin.users',
              },
            },
          },
          {
            path: 'entities',
            element: <EntitiesPage />,
            handle: {
              crumb: {
                i18nKey: 'nav.menu.superadmin.entities',
              },
            },
          },
        ],
      },
    ],
  },
];
